import { useRef } from "react";
import { Button } from "../ui/Button.js";
import { Dialog } from "../ui/Dialog.js";

/**
 * Potwierdzenie zakonczenia treningu: okno decyzji na prymitywie Dialog, w tym samym wzorze co ConfirmDialog, ale z
 * przyciskiem primary zamiast czerwonego.
 *
 * Wypelniona czerwien (danger-solid, DG-1) jest zarezerwowana dla akcji niszczacych, a zakonczenie treningu niczego nie
 * niszczy: rozmowa zostaje i dostaje ocene. Dlatego tu jest zwykly primary z konkretnym czasownikiem (CP-3).
 *
 * - tytul jest pytaniem (D-4), a przycisk nosi czasownik skutku, nigdy "OK" ani "Tak";
 * - fokus startowy siedzi na "Anuluj" i bierze sie z JAWNEGO refa, nie z kolejnosci w DOM (D-4);
 * - klik w tlo i Esc TYLKO zamykaja, nigdy nie koncza treningu (D-3);
 * - DG-5: w trakcie zakonczenia (ocena trwa kilka sekund) przycisk jest zajety (spinner i blokada drugiego klikniecia),
 *   a okno nie daje sie zamknac, bo zakonczenia nie da sie juz wycofac. Zamyka je strona, gdy zadanie sie skonczy.
 */
export function PotwierdzenieZakonczenia({
  otwarty,
  onPotwierdz,
  onAnuluj,
  zajety = false,
}: {
  otwarty: boolean;
  onPotwierdz: () => void;
  onAnuluj: () => void;
  /** Trwa zakonczenie: przycisk jest zajety, Anuluj i zamkniecie wylaczone. */
  zajety?: boolean;
}): React.JSX.Element {
  const anulujRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog
      otwarty={otwarty}
      onZamknij={zajety ? () => undefined : onAnuluj}
      tytul="Zakończyć ćwiczenie?"
      poczatkowyFokusRef={anulujRef}
      akcje={
        <>
          <Button ref={anulujRef} wariant="secondary" wylaczony={zajety} onClick={onAnuluj}>
            Anuluj
          </Button>
          <Button wariant="primary" zajety={zajety} onClick={onPotwierdz}>
            Zakończ i pokaż ocenę
          </Button>
        </>
      }
    >
      Po zakończeniu nie dopiszesz kolejnych odpowiedzi. Przygotujemy ocenę z Twoich dotychczasowych odpowiedzi. Jeśli ćwiczenie
      nie miało zastosowania w wystarczającej liczbie z nich, zamiast oceny zobaczysz „Za mało danych”.
    </Dialog>
  );
}
